<template>
  <div class="column is-12">
  <qd-collapse class="card is-paddingless mgb-20px" animation="slide">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3">
            <p class="card-header-title">
              {{ $t(title) }}
            </p>
            <a class="card-header-icon">
              <b-icon
                :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <qd-message v-if="messages.length > 0"
            :title="$t('general.problemOccurred')"
            type="is-danger"
            aria-close-label="Close message">
            <p v-for="(message, index) in messages" :key="index">
              {{$t(message.message, message.parametres)}}
            </p>
          </qd-message>
          <qd-message v-if="dataIsReady"
            :title="$t('importDonne.infoDataPret.title')"
            type="is-success"
            has-icon
            aria-close-label="Close message">
            <span>{{$t('importDonne.infoDataPret.message')}}</span>
          </qd-message>
          <div class="content">
            <span v-html="$t(description)"></span>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="template">
            {{ $t('importDonne.actions.template') }}
          </a>
          <a class="card-footer-item" @click="popUpImportDonne = true">
            {{ $t('importDonne.actions.importer') }}
          </a>
          <a v-if="hasTest"
            class="card-footer-item"
            :class="{ 'disabled': !result.length }"
            @click="openPopUpPrevention(true)">
            {{ $t('importDonne.actions.testerDonnees') }}
          </a>
          <a
            class="card-footer-item"
            :class="{ 'disabled': !result.length }"
            @click="openPopUpPrevention(false)">
            {{ $t('importDonne.actions.envoyer') }}
          </a>
        </footer>
      </qd-collapse>
    <b-modal v-model="popUpImportDonne" has-modal-card class="modal">
      <import-donne @lignesXlsx="importLigne" :all-sheet="true"></import-donne>
    </b-modal>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <prevention
        :messHeader="$t(`importDonne.${isUserImport ? 'preventionUser' : 'prevention'}`)"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="popUpPrevention = false"
        @yes="importData(false)">
      </prevention>
    </b-modal>
    <b-modal v-model="popUpPreventionFile" has-modal-card class="modal">
      <prevention
        :messHeader="$t('importDonne.preventionFile')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.download')"
        @no="popUpPreventionFile = false"
        @yes="downloadFileError">
      </prevention>
    </b-modal>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import importDonne from '@/components/import/p_importDonne';
import prevention from '@/components/general/popUpPrevention';
import indexOfMessages from '@/services/validation/indexOfMessages';

export default {
  props: {
    type: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    template: {
      type: Function,
      required: true,
    },
    generate: {
      type: Function,
      required: true,
    },
    generateErrorHandler: {
      type: Function,
      required: true,
    },
    importHandler: {
      type: Function,
      required: true,
    },
    importErrorHandler: {
      type: Function,
      required: true,
    },
    hasTest: {
      type: Boolean,
      default: false,
    },
    allSheet: {
      type: Boolean,
      default: false,
    },
    renderAnErrorFile: {
      type: Boolean,
      default: false,
    },
    isUserImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataIsReady: false,
      result: [],
      popUpImportDonne: false,
      popUpPrevention: false,
      popUpPreventionFile: false,
      dataWithErrors: [],
      messages: [],
    };
  },
  components: {
    importDonne,
    prevention,
  },
  methods: {
    resetImport() {
      this.result = [];
      this.messages = [];
      this.dataIsReady = false;
    },
    downloadFileError() {
      this.importErrorHandler(this.dataWithErrors);
      this.popUpPreventionFile = false;
    },
    async importLigne(lignes) {
      this.popUpImportDonne = false;
      this.resetImport();
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.result = await this.generate(lignes);
        this.dataIsReady = this.result && this.result.length > 0;
      } catch (e) {
        if (e && Array.isArray(e)) {
          this.messages = e.map(e => {
            if (e.total) {
              return {
                message: 'importationClient.ligneTotal',
                parametres: { errors: e.totalErrors, total: e.total },
              };
            }
            if (e.general) {
              return {
                message: 'importDonne.messages.error.general',
                parametres: { errors: this.generateErrorHandler(e.general) },
              };
            }
            return {
              message: 'importDonne.messages.error.texte',
              parametres: { num: e.numLigne + 1, errors: this.generateErrorHandler(e.errors) },
            };
          });
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    openPopUpPrevention(isModeTest) {
      if (!isModeTest) {
        this.popUpPrevention = true;
        return;
      }
      this.importData(true);
    },
    async importData(modeTest) {
      this.popUpPrevention = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.dataIsReady = false;
        await this.importHandler(this.result, modeTest);
        messageSuccess(modeTest ? this.$t('importDonne.sucessTestImport') : this.$t('importDonne.success'));
        this.popUpPreventionFile = false;
      } catch (e) {
        this.popUpPreventionFile = false;
        if (this.renderAnErrorFile && Array.isArray(e) && e.length > 0) {
          this.dataWithErrors = e;
          this.popUpPreventionFile = true;
          return;
        }
        if (e.response?.data?.error) {
          this.messages = [];
          if (e.response.data.error.validationErrors) {
            const errorByLines = indexOfMessages(e.response.data.error.validationErrors);
            errorByLines.forEach(e => {
              const errorMessages = [];
              this.importErrorHandler(e.errors, errorMessages);
              if (e.errors.data.error.validationErrors.length !== errorMessages.length) errorMessages.push({ message: 'general.problemOccurred' });
              this.messages.push({
                message: 'importDonne.messages.error.texte',
                parametres: { num: e.numLigne, errors: errorMessages.map(m => this.$t(m.message)).join(' - ') },
              });
            });
          }
          if (this.messages.length === 0) this.messages.push({ message: 'general.problemOccurred' });
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>

<style>

</style>
